import { __awaiter } from "tslib";
import { getSponsoredWidgetsByDeviceMetadata, getSponsoredWidgetsByWidgetId, } from 'pathfinder/api/sponsoredWidgets/sponsoredWidget';
import { chooseSponsoredWidget } from 'pathfinder/utils/sponsoredWidgets/chooseSponsoredWidget';
import { chooseSponsoredWidgetState } from 'pathfinder/utils/sponsoredWidgets/chooseSponsoredWidgetState';
import { chooseImage } from 'pathfinder/utils/sponsoredWidgets/chooseImage';
export function getSponsoredSitewideLogo(isForced) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const widgetType = 'sponsored-sitewide-logo';
        if (isForced) {
            const { getMockedSponsoredSitewideLogos } = yield import(
            /* webpackChunkName: "sponsoredWidgetsMockedData" */ 'pathfinder/api/sponsoredWidgets/mockedData');
            return getMockedSponsoredSitewideLogos();
        }
        const sponsoredSitewideLogos = (_a = (yield getSponsoredWidgetsByWidgetId(widgetType))) !== null && _a !== void 0 ? _a : (yield getSponsoredWidgetsByDeviceMetadata(widgetType));
        if (!sponsoredSitewideLogos || !sponsoredSitewideLogos.length) {
            return null;
        }
        return sponsoredSitewideLogos;
    });
}
export function getSponsoredSitewideLogoBaseData(sponsoredLogos, isForced, device) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const widgetType = 'sponsored-sitewide-logo';
        const sizeDesktop = { width: 112, height: 40 };
        const sizeMobile = { width: 117, height: 30 };
        const chosenSponsoredLogo = isForced
            ? sponsoredLogos[0]
            : chooseSponsoredWidget(sponsoredLogos !== null && sponsoredLogos !== void 0 ? sponsoredLogos : [], device, widgetType);
        if (!chosenSponsoredLogo) {
            return null;
        }
        const chosenSponsoredLogoState = chooseSponsoredWidgetState((_a = chosenSponsoredLogo.states) !== null && _a !== void 0 ? _a : [], device, widgetType, chosenSponsoredLogo === null || chosenSponsoredLogo === void 0 ? void 0 : chosenSponsoredLogo.id);
        if (!chosenSponsoredLogoState) {
            return null;
        }
        const desktopImage = chooseImage((_b = chosenSponsoredLogoState.images) !== null && _b !== void 0 ? _b : [], sizeDesktop, widgetType, chosenSponsoredLogo.id, chosenSponsoredLogoState.id);
        const mobileImage = chooseImage((_c = chosenSponsoredLogoState.images) !== null && _c !== void 0 ? _c : [], sizeMobile, widgetType, chosenSponsoredLogo.id, chosenSponsoredLogoState.id);
        if (!desktopImage || !mobileImage) {
            return null;
        }
        return Object.assign(Object.assign({}, chosenSponsoredLogoState), { sponsoredSitewideLogoId: chosenSponsoredLogo.id, images: {
                desktop: desktopImage,
                mobile: mobileImage,
            } });
    });
}
